import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Owned } from 'app/model/base/named';

@Metamodel.model({
    abstract: true
})
export abstract class TypeFormat extends Owned {
    public static readonly MODEL: IModel;
    public static readonly ENCODING_NAME: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Encoding,
        templatable: true,
        association: 'ENCODING_NAME'
    })
    public encodingName?: string;
}
